export default "__VITE_ASSET__DuMimQvQ__"